<div class="m-navbar">
  <div
    class="container-fluid d-flex justify-content-between align-items-center">
    <div class="m-n-brand m-left">
      <a routerLink="/" class="m-n-brand__logo">
        <img class="logo" src="assets/logos/logo-full.svg" alt="LSH" />
      </a>
    </div>
    <div class="ms-auto me-3 d-flex align-items-center">
      <app-quick-add-menu></app-quick-add-menu>
      <app-view-menu></app-view-menu>
      <app-user-menu></app-user-menu>
    </div>
  </div>
</div>
